export const CHAIN_ID = {
  MAINNET: "0x1",
  ROPSTEN: "0x3",
  RINKEBY: "0x4",
  GOERLI: "0x5",
  KOVAN: "0x2a",
};
